import { CourseWareTypeList, OppositeUserType } from "../polyfills";
import Copy from "copy-to-clipboard";
import { message } from "antd";
import {
    ChatMessageItem,
    FileContent,
    MsgType,
    SessionListItem,
    SimpleSessionItem
} from "../types";
import { pick } from "underscore";
import { Uploader } from "./uploadManager";

// 根据后缀名获取文件类型
export function getFileType(suffixName?: string) {
    if (!suffixName) return "";
    type keyType = keyof typeof CourseWareTypeList;

    for (const type in CourseWareTypeList) {
        const typeList = CourseWareTypeList[type as keyType];
        if (typeList.includes(suffixName.toLowerCase())) return type;
    }

    return "";
}

//复制
export function copyToClipboard(content?: string) {
    if (!content) return;
    Copy(content);
    message.success("已复制到剪切板");
}

// 下载
export function downloadFile({
    fileName,
    fileUrl
}: {
    fileUrl: string;
    fileName: string;
}) {
    const newUrl = `${fileUrl}?attname=${encodeURIComponent(fileName)}`;
    window.open(newUrl);
}

// 等待
export function sleep(millisecond: number) {
    return new Promise(resolve => setTimeout(resolve, millisecond));
}

// 获取简要消息内容
export function getBriefMessageContent(message?: ChatMessageItem) {
    if (!message) return "暂无记录";
    if (message.type === MsgType.TEXT) return message.content.substring(0, 50);
    if (message.type === MsgType.FILE) return "[文件]";
    return "";
}

// 获取完整消息内容, 主要为剪贴板复制用
export function getFullMessageText(message?: ChatMessageItem): string {
    if (!message) return "";
    if (message.type === MsgType.TEXT) return message.content || "";

    if (message.type === MsgType.FILE) {
        try {
            const data = getFileMessageContent(message.content);
            return data?.filename || "";
        } catch (e) {
            return "";
        }
    }

    return "";
}

// 获取简要会话
export function getBriefSession(
    senderFlag: string,
    session: SessionListItem
): SimpleSessionItem {
    const lastMsg = session.chatMessages
        ? session.chatMessages[session.chatMessages.length - 1]
        : undefined;

    const lastSessionTime = lastMsg
        ? lastMsg.sendDate
        : session.lastSessionTime;

    const lastMsgContent = getBriefMessageContent(lastMsg);

    const chatMember = session.chatConferees.find(
        item => item.type === OppositeUserType
    );
    const userNo = chatMember?.no || "";

    const hasNewMessage = !!session.notReadNoTypeList?.includes(senderFlag);

    const data = pick(session, ["guid", "sessionTopic"]);

    return {
        ...data,
        userNo,
        lastMsgContent,
        lastSessionTime,
        hasNewMessage
    };
}

// 生成发送者标识
export function makeSenderFlag({ no, type }: { no: string; type: string }) {
    return `${no}-${type}`;
}

// 模拟上传
export const mockUploader: Uploader = async (file, onProgress) => {
    let percent = 0;

    return new Promise<string>((resolve, reject) => {
        const timeout = setInterval(() => {
            percent++;
            onProgress(percent);

            if (percent === 100) {
                clearInterval(timeout);
                if (Math.random() > 0.5) {
                    reject("Network Error");
                }

                resolve(
                    "https://niu.edufe.com.cn/FhZE3dj3kAuHCEJ9J4lSm4naNz6F"
                );
            }
        }, 20);
    });
};

// 生成文件消息的内容体
export function makeFileMessageContent(file: File, url?: string) {
    const filename = file.name;
    const filesize = file.size;
    const type = file.type;
    return JSON.stringify({ filename, url, filesize, type });
}

// 获取文件消息内容
export function getFileMessageContent(
    jsonText: string
): FileContent | undefined {
    try {
        return JSON.parse(jsonText) as FileContent;
    } catch (e) {
        return;
    }
}

// 获取列表中的最后一条
export function getLastItem<T>(list: T[]): T | undefined {
    return list[list.length - 1];
}
